import { ApexAutomationList } from '../../../general/apex-classes';
import React from 'react';
export const ApexClassAutomationTab = ({ index, sonarObjectId }) => {
    const uri = `v2/salesforce/sfApexClasses/${sonarObjectId}/automations`;
    return (React.createElement(ApexAutomationList, { parentIndex: index, uri: uri }));
};
